import { render, staticRenderFns } from "./CreateOrEditAdminPurchase.vue?vue&type=template&id=ee3bf3ba&scoped=true&"
import script from "./CreateOrEditAdminPurchase.vue?vue&type=script&lang=js&"
export * from "./CreateOrEditAdminPurchase.vue?vue&type=script&lang=js&"
import style0 from "./CreateOrEditAdminPurchase.vue?vue&type=style&index=0&id=ee3bf3ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee3bf3ba",
  null
  
)

export default component.exports